import pako from 'pako'

import { PlaceV0, Position } from '../data/model'

export function deserializeV0(encodedBytes: string): PlaceV0 {
  const eBytesNoVersion = encodedBytes.startsWith('WSID-v0-')
    ? encodedBytes.replace('WSID-v0-', '')
    : encodedBytes
  const decodedBytes = window.atob(eBytesNoVersion)

  const charData = decodedBytes.split('').map((x: string): number => x.codePointAt(0) as number)
  const binData = new Uint8Array(charData)
  const data = pako.inflate(binData, { to: 'string' })

  const jsonObj = JSON.parse(data) as Record<string, unknown>

  return {
    access: jsonObj.access as Position,
    address: (jsonObj.address_text as string) || (jsonObj.address as string),
    categoryId: jsonObj.category_id as string,
    countryCode: jsonObj.country_code as string,
    id: jsonObj.id as string,
    placeType: jsonObj.place_type as string,
    politicalView: jsonObj.political_view as string,
    position: jsonObj.position as Position,
    title: jsonObj.title as string,
  }
}
